<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import {
  ENGAGEMENT_ICONS,
  EngagementActionMixin,
} from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";
import ButtonActionOptions from "%/dynamic-component-editor/bundles/button-action-options";
import ActiveActionIcon from "%/dynamic-component-editor/options/active-action-icon";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import {
  VOTE_UP,
  engagementFieldsFromStoryPageRecord,
  tapStoryVote,
} from "%/dynamic-component-editor/standard-components/base-story-card/story-engagement-actions";

export default {
  name: "UpvoteAction",
  actionLabel: "Upvote",
  elementPanelSettings: {
    displayIcon: "bxs:up-arrow",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [StoryPageElementMixin, EngagementActionMixin],
  options: [
    new ActiveActionIcon({ "default": ENGAGEMENT_ICONS.upvoted }),
  ],
  optionBundles: [
    new ButtonActionOptions({ "default.icon": ENGAGEMENT_ICONS.upvote }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canVoteOnPosts",
    ]),
    suppressPaddingAdjustment() {
      return true;
    },
    isEngagementActive() {
      return Number(this.entity?.voteStatus) === VOTE_UP;
    },
    myValue() {
      return this.myDisplayValue === "show" ? this.entity?.upvoteScore ?? 0 : "";
    },
    shouldShowAction() {
      return this.editMode || this.canVoteOnPosts;
    },
  },
  methods: {
    handleClick() {
      if (this.editMode || this.isPreviewMode || !this.canVoteOnPosts) {
        return;
      }
      tapStoryVote(this.storyEntityId, engagementFieldsFromStoryPageRecord(this.entity), VOTE_UP);
    },
  },
};
</script>
